import { useState, useEffect, useRef, useContext } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card } from "react-bootstrap";
import DateTimePicker from "react-datetime-picker";
import { MultiSelect } from "react-multi-select-component";

import _ from "lodash";
import axios from "axios";
import moment from "moment";  
import Utils from "../../common/Utils";
import { UserContext } from "../../common";

const RotaForm = (props) => {
  const { userData } = useContext(UserContext);
  const refs = {
    fd: useRef(0),
    am: useRef(0),
    pm: useRef(0)
  };


  const initMemberState = (slots=false) => {
    console.log(slots);
    let dt = {
      fd: slots ? _.map(_.filter(slots,ru => ru.slot==='fd'),ru => ({label: ru.user_id===userData.uid ? 'Myself' : ru.ruser.split('#')[0], value: ru.user_id})) : [],
      am: slots ? _.map(_.filter(slots,ru => ru.slot==='am'),ru => ({label: ru.user_id===userData.uid ? 'Myself' : ru.ruser.split('#')[0], value: ru.user_id})) : [],
      pm: slots ? _.map(_.filter(slots,ru => ru.slot==='pm'),ru => ({label: ru.user_id===userData.uid ? 'Myself' : ru.ruser.split('#')[0], value: ru.user_id})) : []
    };
    dt.fd = _.filter(dt.fd,r => parseInt(r.value) > 0);
    dt.am = _.filter(dt.am,r => parseInt(r.value) > 0);
    dt.pm = _.filter(dt.pm,r => parseInt(r.value) > 0);
    
    return dt;
  };

  const [data, setData] = useState(props.mode === 2 ? props.data : {});
  const [members, setMembers] = useState(initMemberState(_.get(data,'rUsers',{})));
  
  const [selBranch, setSelBranch] = useState(_.get(props,'data.branch_id',0));
  const [selRoom, setSelRoom] = useState(_.get(props,'data.room_id',0));

  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState();

  const title = ["","Create Rota","Edit Rota"];

  useEffect(() => {
    setData({...data,rota_date: moment(_.get(data,'rota_date',moment(_.get(props,'defaultDate','')))).toDate()});
  },[]);

  const saveRota = (addMore) => {
    setSaving(true);
    const pvals = {
      rota_id: _.get(data,'id',0),
      rota_date: moment(data.rota_date).format("YYYY-MM-DD"),
      branch_id: selBranch,
      room_id: selRoom,
      fd: _.map(members.fd, d => d.value),
      am: _.map(members.am, d => d.value),
      pm: _.map(members.pm, d => d.value),
    };
    axios
      .post(
        Utils.apiUrl("users/saveRota"),
        Utils.postVars(pvals),
        Utils.apiHeaders()
      )
      .then((res) => {
        setSaving(false);
        setMessage(res.data.message);
        if(res.data.success) {
          props.afterSave(res.data);
          if(addMore===1){
            window.setTimeout(() => {
              setMessage("");
              setSelBranch(0);
              setSelRoom(0);
              setMembers(initMemberState());
            },1000);
          }else{
            props.onHide();
          }
        }
      })
      .catch((err) => {
        setSaving(false);
        console.log(err);
      });
  };

  const renderMultiSelect = (slot) => {
    const udata = Utils.getUserData();
    let data = [{ label: "Myself", value: udata.uid }];
    props.orgMembers.map((tm) => {
      //if(tm.branch_id===selBranch){
        data.push({ label: `${tm.title} ${tm.name}`, value: tm.id });
      //}
    });
    
    return <MultiSelect required disabled={selBranch===""} options={data} name={slot} value={members[slot]} onChange={(v) => {
      let m = {...members};
      m[slot] = v;
      setMembers({...m});
    }} ref={refs[slot]} />;
  };
  
  return (
    <>
      <Modal show size="lg" onHide={props.onHide} centered>
        <Form className="needs-validation" onSubmit={saveRota}>
          <Modal.Header closeButton>
            <Modal.Title>{title[props.mode]}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <Card className="my-3">
              <Card.Body>
                {saving && (
                  <Alert variant="info" className="p-3">
                    <p className="loading-msg">saving data..</p>
                    <ProgressBar variant="info" animated now={100} />
                  </Alert>
                )}
                {!saving && <>
                  {message!=='' && (
                    <Alert variant="warning" className="p-3">{message}</Alert>
                  )}
                    <div className="row">
                      <div className="col-sm-4 mb-3 py-1"><Form.Label>Select Date</Form.Label></div>
                      <div className="col-sm-8 mb-3">
                        <DateTimePicker
                          disableClock={true}
                          minDate={moment().toDate()}
                          clearIcon={null}
                          format="y-MM-dd"  
                          required={true}
                          onChange={(v) => setData({...data, rota_date: v })}
                          value={data.rota_date}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4 mb-3 py-1"><Form.Label>Branch Name</Form.Label></div>
                      <div className="col-sm-8 mb-3">
                        <select className="form-select" required={true} onChange={(e) => setSelBranch(e.currentTarget.value)} value={selBranch}>
                          <option value="">Select Branch</option>
                          {_.get(props,'branches',[]).map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4 mb-3 py-1"><Form.Label>Room Name</Form.Label></div>
                      <div className="col-sm-8 mb-3">
                        <select className="form-select" required={true} onChange={(e) => setSelRoom(e.currentTarget.value)} value={selRoom}>
                          <option value="">Select Room</option>
                          {_.get(process.env,'REACT_APP_ROOM_TYPES','').split(',').map((r,idx) => <option key={idx} value={idx}>{r}</option>)}
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-4 mb-3 py-1"><Form.Label>Full Day</Form.Label></div>
                      <div className="col-sm-8 mb-3">{renderMultiSelect('fd')}</div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4 mb-3 py-1"><Form.Label>AM</Form.Label></div>
                      <div className="col-sm-8 mb-3">{renderMultiSelect('am')}</div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4 mb-3 py-1"><Form.Label>PM</Form.Label></div>
                      <div className="col-sm-8 mb-3">{renderMultiSelect('pm')}</div>
                    </div>
                    
                  </>}
                
                
              </Card.Body>
            </Card>
          </Modal.Body>
          {!saving && <Modal.Footer className="text-cemter">
            {props.mode===1 && <Button type="button" variant="success" className="py-1 px-4" onClick={() => saveRota(1)}>Save & Add More</Button>}
            <Button type="button" variant="primary" className="py-1 px-4" onClick={() => saveRota(0)}>Submit</Button>
          </Modal.Footer>}
        </Form>
      </Modal>
    </>
  );
};

export default RotaForm;
